import { put } from '../index';

export function editTimeLine({ id, body }) {
  return put(id, body, false);
}
